//
// ButtonDirection.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ButtonDirection = {
    HORIZONTAL:0,
    VERTICAL:1
};
export default ButtonDirection;
